import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

const CARD_WIDTH_DESKTOP = 392;
const CARD_WIDTH_MOBILE = 332;

export const Card = withViewportStyle("div")`
  display: inline-block;
  width: 100%;
  max-width: ${rem(CARD_WIDTH_DESKTOP)};
  margin: ${rem(12)} ${rem(12)};

  ${(props) => props.$viewport.mobile`
    max-width: ${rem(CARD_WIDTH_MOBILE)};
  `}
`;

export const Content = styled.div`
  display: grid;
  justify-items: start;
  gap: ${rem(8)};
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  padding-bottom: ${rem(16)};
`;

export const Media = withViewportStyle("img")`
  display: block;
  height: ${rem(CARD_WIDTH_DESKTOP)};
  width: ${rem(CARD_WIDTH_DESKTOP)};
  object-fit: cover;

  ${(props) => props.$viewport.mobile`
    width: 100%;
    height: ${rem(CARD_WIDTH_MOBILE)};
  `}
`;

export const StyledName = styled.div`
  display: flex;
  margin: ${rem(16)} ${rem(16)} 0;

  .text-primitive {
    text-align: left;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;

export const StyledHeadline = styled.div`
  display: flex;
  margin: ${rem(4)} ${rem(16)} ${rem(40)} ${rem(16)};

  .text-primitive {
    text-align: left;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;

export const Actions = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${rem(20)};
  margin-left: ${rem(16)};
  margin-right: ${rem(16)};
`;
